export default{

    computed:{
        //费用类型
        getCostType(){
            return [
                { value: 1, label: '仓库作业费' },
				{ value: 2, label: '配送费' },
				{ value: 3, label: '增值服务费' },
				{ value: 4, label: '仓储费' },
				{ value: 5, label: '包材费' },
				{ value: 6, label: '调账费' },
            ]
        },
        //调账类型
        getAdjutmentType(){
            return [
                { value: 0, label: '调账扣减' },
                { value: 1, label: '调账返还' },
            ]
        },
        //单据类型
        getBillType(){
            return [
                {value:0,label:'收入'},
                {value:1,label:'支出'},
            ]
        },
        //二级分类
        getCategory() {
            return [
                {
                    label: '充值',
                    value: '11'
                }, 
                // {
                //     label: '扣款',
                //     value: '12'
                // }, 
                {
                    label: '解冻',
                    value: '13'
                },
                {
                    label: '调账返还',
                    value: '14'
                },
                {
                    label: '冻结',
                    value: '21'
                }, 
                {
                    label: '仓库作业费',
                    value: '22'
                },
                {
                    label: '调账扣减',
                    value: '23'
                },
                {
                    label: '仓储费',
                    value: '24'
                },
                {
                    label: '增值服务费',
                    value: '25'
                },
                {
                    label: '包材费',
                    value: '26'
                },
                {
                    label: '配送费',
                    value: '27'
                }
            ]
        },
    }
}